<h1 mat-dialog-title>{{ title() }}</h1>
<mat-dialog-content [formGroup]="form">
  <p>Select a reason:</p>
  <div class="flex-col gap-5">
    <mat-radio-group class="flex-col flex-wrap gap-10" formControlName="statusReason" (change)="reasonChanged($event)">
      <mat-radio-button *ngFor="let reason of reasons" [value]="reason">
        {{ getRoomStatusReasonLabel(reason) }}
      </mat-radio-button>
    </mat-radio-group>
    <div *ngIf="showClosedDate" class="closed-date-fields flex-row flex-wrap gap-10">
      <mat-form-field appearance="fill">
        <mat-label>Closed month (optional)</mat-label>
        <mat-select formControlName="closedMonth">
          <mat-option [value]="null">Unknown / unspecified</mat-option>
          <mat-option *ngFor="let month of monthOptions" [value]="month.value">{{ month.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Closed year</mat-label>
        <mat-select formControlName="closedYear" required>
          <mat-option *ngFor="let y of yearOptions" [value]="y">{{ y }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-form-field *ngIf="needsCustomReason()" appearance="fill">
      <mat-label>Custom reason</mat-label>
      <textarea matInput #customReasonInput="matInput" formControlName="customReason"
                cdkTextareaAutosize cdkAutosizeMinRows="2" required></textarea>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Notes</mat-label>
      <textarea matInput formControlName="note" required
                cdkTextareaAutosize cdkAutosizeMinRows="2"></textarea>
      <mat-hint>Required. Document this decision in the audit log.</mat-hint>
    </mat-form-field>
  </div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="secondary" (click)="cancel()">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!formIsValid()">
    {{ submitLabel() }}
  </button>
</div>
